import './fonts.css';
import '@fontsource/chakra-petch/500.css';
import '@fontsource/chakra-petch/600.css';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './index.css';
import './i18n';

import { configureApi, configureEcho, setApiLocale } from '@ottd/api';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ThemeProvider } from './components/theme-provider';
import { activeLocale } from './lib/locale';

// Configure the shared clients at module load so config lands before the first
// query / socket subscription (see AuthProvider's on-mount bootstrap). The
// language travels with every request as `Accept-Language`, so the strings the
// backend renders itself arrive in the same language as the UI.
configureApi({ baseUrl: import.meta.env.VITE_BACKEND_URL });
setApiLocale(activeLocale());
configureEcho({
  key: import.meta.env.VITE_REVERB_APP_KEY,
  host: import.meta.env.VITE_REVERB_HOST,
  port: import.meta.env.VITE_REVERB_PORT,
  scheme: import.meta.env.VITE_REVERB_SCHEME,
});

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
